import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopandharpur() {



  const cardData =
  {
    keyword: 'Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking ',
    heading: 'Shambhu Cabs: Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Pandharpur, Akkalkot, and Tuljapur Cab Booking services, providing safe, comfortable, and hassle-free travel for pilgrims, families, and groups visiting these holy towns. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Pandharpur, Akkalkot, and Tuljapur with spacious seating and well-maintained vehicles. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes your pilgrimage or spiritual journey convenient, stress-free, and memorable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted cab services for travelers seeking comfort, safety, and a reliable travel experience to these sacred destinations.',

    top: 'Top Places to Visit in Pandharpur with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Pandharpur Vitthal Temple",
    "description": "The Pandharpur Vitthal Temple is one of Maharashtra’s most revered pilgrimage sites dedicated to Lord Vitthal (Vithoba), an incarnation of Lord Krishna. Located on the banks of the Bhima River, the temple attracts hundreds of thousands of devotees, especially during the Ashadhi Ekadashi and Kartiki Ekadashi festivals. Pilgrims perform the traditional 'Wari' procession on foot from various parts of Maharashtra, making it a center of devotion, Bhakti tradition, and cultural heritage."
  },
  {
    "title": "Akkalkot Swami Samarth Maharaj Temple",
    "description": "The Akkalkot Temple is dedicated to Swami Samarth Maharaj, a 19th-century saint regarded as an incarnation of Lord Dattatreya. Known for his miracles and teachings of spiritual enlightenment, the temple draws devotees from across India. Visitors experience a serene atmosphere, participate in daily prayers, and witness rituals and festivals celebrating Swami Samarth, making Akkalkot a major spiritual hub in Maharashtra."
  },
  {
    "title": "Tuljapur Tulja Bhavani Temple",
    "description": "Tulja Bhavani Temple, located in Tuljapur, is one of Maharashtra’s 51 Shakti Peethas and is dedicated to Goddess Bhavani. Revered as the family deity of the Marathas, the temple has historical and spiritual significance. Pilgrims climb the hill to reach the sanctum, participate in traditional aartis, and explore the surrounding scenic area. The temple is especially crowded during Navratri, offering a profound spiritual and cultural experience."
  },
  {
    "title": "Pandharpur Bhima River Ghats",
    "description": "The ghats along the Bhima River in Pandharpur are integral to pilgrimage rituals. Devotees bathe in the holy river before visiting the Vitthal Temple, participating in prayers and communal gatherings. The ghats are especially vibrant during the Ashadhi Wari, when thousands of pilgrims converge, creating a spiritual and colorful atmosphere along the riverbanks."
  },
  {
    "title": "Akkalkot Maharaj Samadhi",
    "description": "The Samadhi of Swami Samarth in Akkalkot is a sacred spot where devotees pay homage to the saint after his physical departure. The site is known for its peaceful ambiance, spiritual energy, and continuous chanting of prayers. Visitors often seek blessings, meditate, and participate in devotional singing sessions (bhajans), experiencing the saint’s legacy firsthand."
  },
  {
    "title": "Tuljapur Fort",
    "description": "Tuljapur Fort, situated near the Tulja Bhavani Temple, is a historical landmark dating back several centuries. It was a strategic site during the Maratha era and provides panoramic views of the surrounding town. Visitors can explore the fort’s bastions, gates, and historical structures, which complement the spiritual journey with a touch of history and architectural interest."
  },
  {
    "title": "Pandharpur Wari Festival",
    "description": "The Pandharpur Wari Festival is a grand annual pilgrimage that attracts hundreds of thousands of devotees walking from various towns to the Vitthal Temple. It is marked by devotional singing (abhangas), dancing, and community service. This centuries-old tradition embodies Maharashtra’s Bhakti movement, communal harmony, and deep-rooted cultural practices."
  },
  {
    "title": "Akkalkot Market and Pilgrim Streets",
    "description": "The streets around Akkalkot Temple are bustling with pilgrims and vendors selling religious items, souvenirs, prasads, and local snacks. Walking through these streets provides insight into the local culture, devotional practices, and community life centered around the temple. It’s a vibrant area reflecting both spiritual and everyday life in Akkalkot."
  },
  {
    "title": "Tuljapur Local Handicrafts",
    "description": "Tuljapur is also known for its local handicrafts, including religious idols, traditional textiles, and decorative items. Visitors often explore shops near the temple to purchase souvenirs and offerings. These handicrafts reflect the region’s cultural heritage and provide an opportunity to support local artisans while complementing the spiritual journey."
  },
  {
    "title": "Bhavani River and Surrounding Hills",
    "description": "The Bhavani River flowing near Tuljapur adds natural beauty to the pilgrimage experience. Surrounded by scenic hills, it provides a tranquil setting for reflection, meditation, and photography. Pilgrims often enjoy the serene environment before or after visiting the Tulja Bhavani Temple, making it both a spiritual and natural attraction."
  }
],



"services": [
  {
    "name": "Pandharpur Cab Mumbai",
    "description": "Pandharpur Cab Mumbai offers dedicated temple travel from Mumbai to Pandharpur with experienced chauffeurs, comfortable AC vehicles, and timely pickups. This service ensures smooth travel for devotees visiting Vitthal Rukmini Mandir, offering flexible one-way, round-trip, and same-day darshan cab options. Ideal for families, senior citizens, and pilgrimage groups, the service guarantees safe highway travel, clean cars, and 24×7 availability for spiritual journeys."
  },
  {
    "name": "Mumbai to Tuljapur Taxi",
    "description": "Mumbai to Tuljapur Taxi provides reliable and comfortable travel to Tulja Bhavani Temple with doorstep pickup, professional drivers, and well-maintained sedans/SUVs. Devotees can enjoy a peaceful and stress-free journey along the Solapur–Osmanabad route with flexible timings and customized darshan cab schedules. This service is perfect for early-morning temple trips, family travel, and multi-temple routes covering Solapur and surrounding regions."
  },
  {
    "name": "Akkalkot Trip Cab",
    "description": "Akkalkot Trip Cab ensures a smooth and devotional ride to Shri Swami Samarth Temple from Mumbai. With trained chauffeurs, clean cars, and flexible packages, devotees can travel comfortably for darshan and local sightseeing. The service supports same-day return, multi-temple combinations, and long-route pilgrimage travel for spiritual comfort and convenience."
  },
  {
    "name": "Bhakt Niwas Drop Cab",
    "description": "Bhakt Niwas Drop Cab offers convenient direct drop service from Mumbai to various Bhakt Niwas accommodations in Pandharpur, Tuljapur, Akkalkot, and Solapur. The service ensures smooth check-in assistance, timely drop-off, and safe travel for families and senior pilgrims with trained drivers familiar with temple routes and nearby lodging locations."
  },
  {
    "name": "Mumbai to Pandharpur Darshan Cab",
    "description": "Mumbai to Pandharpur Darshan Cab provides a comfortable spiritual journey for devotees visiting Vitthal Rukmini Mandir. With early-morning departures, customizable itineraries, experienced drivers, and spacious vehicles, this service offers a peaceful devotional experience. Suitable for family groups, elderly travellers, and multi-temple circuits such as Pandharpur–Tuljapur–Akkalkot."
  },
  {
    "name": "Outstation Temple Cab Mumbai",
    "description": "Outstation Temple Cab Mumbai specializes in pilgrimage trips covering Maharashtra’s major temples including Pandharpur, Tuljapur, Akkalkot, Shirdi, Nashik, and more. The service includes premium vehicles, devotional-friendly drivers, flexible routing, multi-day itineraries, and reliable highway travel ensuring safe and peaceful temple journeys."
  },
  {
    "name": "3 Temple Trip Cab Booking",
    "description": "3 Temple Trip Cab Booking offers a convenient combo package for Pandharpur, Tuljapur, and Akkalkot temple tours from Mumbai. The service ensures seamless transitions between temples with expert drivers, AC sedans/SUVs, planned route timings, and safe long-distance travel for a complete pilgrimage experience."
  },
  {
    "name": "Affordable Mumbai Pandharpur Cab",
    "description": "Affordable Mumbai Pandharpur Cab ensures low-cost long-distance travel for devotees wanting reliable transportation without compromising on comfort or safety. With economical sedans, budget SUVs, flexible timing, transparent fares, and devotional-friendly drivers, this service suits families and devotees seeking value-based temple travel."
  },
  {
    "name": "Mumbai to Akkalkot Taxi",
    "description": "Mumbai to Akkalkot Taxi provides safe and comfortable travel to Swami Samarth Temple with 24×7 availability, skilled drivers, and smooth highway routes. Ideal for same-day darshan, round trips, or multi-temple journeys including Solapur, Tuljapur, and Pandharpur."
  },
  {
    "name": "Tuljapur Bhavani Cab Mumbai",
    "description": "Tuljapur Bhavani Cab Mumbai delivers reliable travel to Tulja Bhavani Mata Mandir with spacious vehicles and devotional-friendly drivers. Passengers enjoy peaceful journeys, flexible darshan slots, and well-managed temple trip schedules suitable for families and groups."
  },
  {
    "name": "Mumbai to Solapur Temple Route Cab",
    "description": "Mumbai to Solapur Temple Route Cab ensures smooth access to major temples along the Solapur belt including Pandharpur, Tuljapur, Akkalkot, and Swami Samarth Mandir. The service is ideal for multi-temple tours, family pilgrimages, and weekend religious travel."
  },
  {
    "name": "24×7 Mumbai Temple Cab",
    "description": "24×7 Mumbai Temple Cab provides round-the-clock availability for all temple routes across Maharashtra. Whether early morning darshan, late-night departures, or multi-day temple tours, the service ensures safe, comfortable, and dependable transportation at any hour."
  },
  {
    "name": "Sedan Cab Mumbai to Pandharpur",
    "description": "Sedan Cab Mumbai to Pandharpur offers a smooth and economical ride with AC sedans ideal for small families and individual travellers. With comfortable seating, luggage space, and skilled temple-route drivers, this service ensures a peaceful devotional journey."
  },
  {
    "name": "SUV Taxi Tuljapur Mumbai",
    "description": "SUV Taxi Tuljapur Mumbai provides spacious and powerful SUVs for family temple trips, offering excellent comfort on long rural routes. Ideal for groups, elderly travellers, and multi-temple journeys including Tuljapur, Pandharpur, and Akkalkot."
  },
  {
    "name": "Family Temple Cab Service",
    "description": "Family Temple Cab Service is designed for safe, comfortable, and devotional travel for families visiting temples across Maharashtra. With sanitized vehicles, knowledgeable drivers, calm driving, and proper stop planning, families enjoy a hassle-free spiritual journey."
  },
  {
    "name": "Pilgrimage Cab Mumbai",
    "description": "Pilgrimage Cab Mumbai specializes in devotional tours including Pandharpur, Shirdi, Nashik, Tuljapur, Akkalkot, Jejuri, Kolhapur, and more. This service offers planned itineraries, trained drivers, clean vehicles, and long-distance comfort for sacred journeys."
  },
  {
    "name": "Long Route Temple Cab",
    "description": "Long Route Temple Cab provides extended pilgrimage travel across Maharashtra with flexible schedules, comfortable vehicles, and expert drivers. Suitable for multi-day temple yatras covering various holy destinations with complete convenience and safety."
  }
],

"tableData": [
  ["Pandharpur Cab Mumbai", "Mumbai to Tuljapur Taxi"],
  ["Akkalkot Trip Cab", "Bhakt Niwas Drop Cab"],
  ["Mumbai to Pandharpur Darshan Cab", "Outstation Temple Cab Mumbai"],
  ["3 Temple Trip Cab Booking", "Affordable Mumbai Pandharpur Cab"],
  ["Mumbai to Akkalkot Taxi", "Tuljapur Bhavani Cab Mumbai"],
  ["Mumbai to Solapur Temple Route Cab", "24×7 Mumbai Temple Cab"],
  ["Sedan Cab Mumbai to Pandharpur", "SUV Taxi Tuljapur Mumbai"],
  ["Family Temple Cab Service", "Pilgrimage Cab Mumbai"],
  ["Long Route Temple Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable cab booking from Mumbai to Pandharpur, Akkalkot, and Tuljapur, perfect for pilgrimage trips, family travel, and comfortable long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable pilgrimage journey across all temple destinations."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Temple Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with routes to Pandharpur, Akkalkot, and Tuljapur, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your temple tour."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized multi-temple cab packages tailored to your pilgrimage schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience for devotees."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth transportation, making your Mumbai to Pandharpur–Akkalkot–Tuljapur pilgrimage peaceful and worry-free."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Pandharpur, Akkalkot, and Tuljapur?',
    answer: 'Yes, Shambhu Cabs offers reliable cab services from Mumbai to Pandharpur, Akkalkot, and Tuljapur for temple tours and spiritual journeys.',
  },
  {
    question: 'How can I book a cab from Mumbai to Pandharpur Akkalkot Tuljapur?',
    answer: 'You can easily book through our website, mobile app, or contact our 24x7 customer support team for hassle-free cab booking from Mumbai.',
  },
  {
    question: 'What types of vehicles are available for the Mumbai to Pandharpur Akkalkot Tuljapur route?',
    answer: 'Shambhu Cabs provides sedans, SUVs, Innova, Crysta, and Tempo Travellers suitable for family and group temple tours.',
  },
  {
    question: 'Are drivers experienced for long-distance temple tours?',
    answer: 'Yes, our drivers are licensed and experienced, especially for pilgrimage routes like Pandharpur, Akkalkot, and Tuljapur, ensuring a safe and smooth journey.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for the Mumbai to Pandharpur Akkalkot Tuljapur tour?',
    answer: 'Absolutely. You can choose any pickup or drop-off point within Mumbai and at the temple locations as per your convenience.',
  },
  {
    question: 'Is cab service available 24x7 from Mumbai to Pandharpur Akkalkot Tuljapur?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab service, allowing you to plan your spiritual journey at any time.',
  },
  {
    question: 'Are safety and hygiene protocols followed during the Mumbai to Pandharpur Akkalkot Tuljapur trip?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene measures for your well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Pandharpur Akkalkot Tuljapur cab booking?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments.',
  },
  {
    question: 'Is customer support available during the entire temple tour?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support throughout your Mumbai to Pandharpur Akkalkot Tuljapur journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'Our Mumbai to Pandharpur Akkalkot Tuljapur trip with Shambhu Cabs was smooth and comfortable. The driver guided us properly and the vehicle was very well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kavita Deshmukh',
    feedback: 'Excellent cab service for our temple tour from Mumbai. Shambhu Cabs made our spiritual journey peaceful and hassle-free.',
    rating: 5,
  },
];





































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur, Akkalkot, Tuljapur Cab Booking",
  "image": "https://www.shambhucab.com/assets/images/pandharpur-tuljapur-cab.jpg",
  "description": "Book cabs from Mumbai to Pandharpur, Akkalkot, and Tuljapur with Shambhu Cabs. Ideal for temple trips, pilgrimages, and outstation travel. Comfortable, safe, and affordable taxi services with sedan and SUV options.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "720",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-pandharpur-akkalkot-tuljapur-cab-booking"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Pandharpur, Akkalkot & Tuljapur Cab Booking | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Pandharpur, Akkalkot, Tuljapur cabs with Shambhu Cabs. Comfortable sedan and SUV cabs for temple trips, pilgrimages, and outstation journeys. 24×7 reliable service."
  />

  <meta
    name="keywords"
    content="Pandharpur Cab Mumbai, Mumbai to Tuljapur Taxi, Akkalkot Trip Cab, Bhakt Niwas Drop Cab, Mumbai to Pandharpur Darshan Cab, Outstation Temple Cab Mumbai, 3 Temple Trip Cab Booking, Affordable Mumbai Pandharpur Cab, Mumbai to Akkalkot Taxi, Tuljapur Bhavani Cab Mumbai, Mumbai to Solapur Temple Route Cab, 24×7 Mumbai Temple Cab, Sedan Cab Mumbai to Pandharpur, SUV Taxi Tuljapur Mumbai, Family Temple Cab Service, Pilgrimage Cab Mumbai, Long Route Temple Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopandharpur;